import { useQuery } from '@tanstack/react-query'
import { experienceLabAccessService } from '@/services/experienceLabAccess'
import { useAuthStore } from '@/stores/auth'

const ACCESS_CACHE_MS = 5 * 60 * 1000

export const experienceLabAccessKeys = {
  access: (userId?: string, organizationId?: string) =>
    ['experienceLabAccess', userId, organizationId] as const,
}

export function useExperienceLabAccess() {
  const userId = useAuthStore((state) => state.user?.id)
  const organizationId = useAuthStore((state) => state.organization?.id)
  const enabled = Boolean(userId && organizationId)

  const { data, isLoading } = useQuery({
    queryKey: experienceLabAccessKeys.access(userId, organizationId),
    queryFn: () => experienceLabAccessService.getAccess(),
    enabled,
    retry: false,
    staleTime: ACCESS_CACHE_MS,
    gcTime: ACCESS_CACHE_MS,
    refetchOnWindowFocus: false,
  })

  return {
    allowed: data?.allowed === true,
    isLoading: enabled && isLoading,
  }
}
